/// <reference types="w3c-web-serial" />

/** The part of `navigator.serial` that announces ports. */
export interface PortAnnouncer {
    addEventListener(type: "connect", listener: (event: Event) => void): void;
    removeEventListener(type: "connect", listener: (event: Event) => void): void;
}

export interface PortReturn {
    cancel(): void;
}

/**
 * Wait for a port with the USB vendor and product ids of `lost` to connect,
 * then pass it to `found`. The browser only announces ports the page already
 * has permission for.
 */
export function awaitPortReturn(
    serial: PortAnnouncer,
    lost: SerialPortInfo,
    found: (port: SerialPort) => void,
): PortReturn {
    const onConnect = (event: Event): void => {
        const port = event.target as SerialPort;
        if (!sameUsbDevice(port.getInfo(), lost)) return;
        stop();
        found(port);
    };
    const stop = (): void => serial.removeEventListener("connect", onConnect);
    serial.addEventListener("connect", onConnect);
    return { cancel: stop };
}

export function sameUsbDevice(a: SerialPortInfo, b: SerialPortInfo): boolean {
    return a.usbVendorId !== undefined && a.usbVendorId === b.usbVendorId && a.usbProductId === b.usbProductId;
}
